import { Tag } from "components/DesignSystem/Tag/Tag";
import { Check } from "components/icons/Check";

export const IncorporationStepStatusChip = ({
  answeredCount,
  totalCount,
}: {
  answeredCount: number;
  totalCount: number;
}) => {
  if (answeredCount === 0) {
    return (
      <Tag tagType="gray" icon={false} rounded size="small">
        Not started
      </Tag>
    );
  }

  if (answeredCount === totalCount) {
    return (
      <Tag tagType="green" icon={false} rounded size="small">
        Completed
      </Tag>
    );
  }

  return (
    <Tag tagType="yellow" icon={false} rounded size="small">
      {answeredCount} of {totalCount} completed
    </Tag>
  );
};
